import "./Chat_Bot.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import MyContext from "../../MyContext";

export default function WhatsAppFlow({ userID }) {
  const { baseUrl, config } = useContext(MyContext);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTamplate] = useState([]);

  const [nodes, setNodes] = useState([
    {
      id: "start",
      text: "Hii",
      content: "",
      x: 50,
      y: window.innerHeight / 2,
      children: [],
      template: [],
    },
  ]);
  const refs = useRef({});
  const dragRefs = useRef({});
  const draggingNode = useRef(null);
  const offset = useRef({ x: 0, y: 0 });
  const [textMessage, setTextMessage] = useState("");
  const [listTitle, setListTitle] = useState("");
  const [interactiveList, setInteractiveList] = useState([]);

  const handleInteractiveListChange = (index, value) => {
    const newList = [...interactiveList];
    newList[index] = value;
    setInteractiveList(newList);
  };

  const addListItem = () => {
    if (interactiveList.length < 5) {
      setInteractiveList([...interactiveList, ""]);
    }
  };

  const removeListItem = (index) => {
    setInteractiveList(interactiveList.filter((_, i) => i !== index));
  };
  const adjustContainerSize = () => {
    const minY = Math.min(...nodes.map((node) => node.y));
    if (minY < 50) {
      setNodes((prevNodes) =>
        prevNodes.map((node) => ({
          ...node,
          y: node.y + Math.abs(minY) + 100, // Push nodes down dynamically
        }))
      );
    }
  };
  useEffect(() => {
    adjustContainerSize();
  }, [nodes]);
  useEffect(() => {
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === "start" ? { ...node, y: window.innerHeight / 2 } : node
      )
    );
  }, []);
  const buttonTypes = [
    "Catalog",
    "Template Message",
    "Text Message",
    "Interactive List",
  ];
  const calculatePosition = (parent, btnIndex, totalButtons) => {
    const verticalSpacing = 200;
    const horizontalSpacing = 500;
    const parentX = parent.x;
    const parentY = parent.y;
    const childX = parentX + horizontalSpacing;
    const childY =
      parentY + (btnIndex - (totalButtons - 1) / 2) * verticalSpacing;
    return { x: childX, y: childY };
  };

  const addNode = (parentId, type, btnIndex) => {
    setNodes((prevNodes) => {
      const parent = prevNodes.find((node) => node.id === parentId);
      if (!parent) return prevNodes;
      if (!parent.children) parent.children = [];
      const newNodeId = `node-${prevNodes.length}`;
      const { x, y } = calculatePosition(parent, btnIndex, buttonTypes.length);
      const newNode = {
        id: newNodeId,
        text: type,
        x,
        y,
        fromButton: btnIndex,
        content: "This is Content of Message",
        children: [],
        template: [],
      };
      parent.children.push({ id: newNodeId, fromButton: btnIndex });
      return [...prevNodes, newNode];
    });
  };

  const handleMouseDown = (e, nodeId) => {
    draggingNode.current = nodeId;
    const node = nodes.find((n) => n.id === nodeId);
    if (node) {
      offset.current = { x: e.clientX - node.x, y: e.clientY - node.y };
    }
  };
  const handleMouseMove = (e) => {
    if (!draggingNode.current) return;
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === draggingNode.current
          ? {
              ...node,
              x: e.clientX - offset.current.x,
              y: e.clientY - offset.current.y,
            }
          : node
      )
    );
  };
  const handleMouseUp = () => {
    draggingNode.current = null;
  };

  const renderNode = (node, level = 0) => {
    return (
      <div key={node.id} style={{ marginLeft: level * 20, padding: "5px" }}>
        {"-->"} {node.text}
        {node.children?.map((child) => {
          const childNode = nodes.find((n) => n.id === child.id);
          return childNode ? renderNode(childNode, level + 1) : null;
        })}
      </div>
    );
  };

  const getVendorAccounts = async (e) => {
    try {
      var raw = JSON.stringify({
        userid: userID,
      });

      var requestOptions = {
        method: "POST",
        headers: config.headers,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${baseUrl}/api/Whatsapp/getTemplates`,
        requestOptions
      );

      const data = await res.json();

      if (data?.responseCode == "00") {
        setTemplates(data?.response.data);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };
  useEffect(() => {
    getVendorAccounts();
  }, []);

  const handleTemplateSelect = (e, nodeId) => {
    const temp = JSON.parse(e);

    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId ? { ...node, template: temp } : node
      )
    );

    setSelectedTamplate(temp);
  };

  return (
    <div
      className="tree-container "
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {/* <div>
        <p>Selected Template</p>

        {JSON.stringify(selectedTemplate)}
      </div> */}

      <h2 className="text-dark">Interactive WhatsApp Flow Builder</h2>
      {/* {JSON.stringify(nodes)}
      <div>
        <div>{nodes.length > 0 && renderNode(nodes[0])}</div>;
      </div> */}
      <svg className="svg-layer">
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="10"
            refY="3.5"
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="#705CFE" />
          </marker>
        </defs>
        {nodes.map((node) =>
          node.children?.map(({ id: childId, fromButton }) => {
            const child = nodes.find((n) => n.id === childId);
            if (!child) return null;

            const parentButtonRef = refs.current[`${node.id}-${fromButton}`];
            if (!parentButtonRef) return null;

            const { x, y, width, height } =
              parentButtonRef.getBoundingClientRect();
            const parentRect = parentButtonRef
              .closest(".node-box")
              .getBoundingClientRect();

            const offsetX = x - parentRect.x + width / 2;
            const offsetY = y - parentRect.y + height / 2;

            const x1 = node.x + offsetX;
            const y1 = node.y + offsetY;
            const x2 = child.x - 10;
            const y2 = child.y + 10;

            // Control point for quadratic Bezier curve
            const controlX = (x1 + x2) / 2;
            const controlY = y1 - 50;

            // Midpoint of the quadratic Bezier curve
            const t = 0.5;
            const bezierX =
              (1 - t) * (1 - t) * x1 + 2 * (1 - t) * t * controlX + t * t * x2;
            const bezierY =
              (1 - t) * (1 - t) * y1 + 2 * (1 - t) * t * controlY + t * t * y2;

            // Calculate the angle of the curve at the midpoint for text rotation
            const dx = 2 * (1 - t) * (controlX - x1) + 2 * t * (x2 - controlX);
            const dy = 2 * (1 - t) * (controlY - y1) + 2 * t * (y2 - controlY);
            const angle = Math.atan2(dy, dx) * (180 / Math.PI);

            return (
              <g key={`${node.id}-${childId}`}>
                {/* Curved path */}
                <path
                  d={`M ${x1},${y1} Q ${controlX},${controlY} ${x2},${y2}`}
                  fill="none"
                  stroke="#705CFE"
                  strokeWidth="2"
                  strokeDasharray="5,5"
                  markerEnd="url(#arrowhead)"
                />

                {/* Background rectangle for text */}
                <g
                  transform={`translate(${bezierX}, ${bezierY}) rotate(${angle})`}
                >
                  <rect
                    x={-child.text.length * 5} // Centering based on text width
                    y={-10} // Centering height
                    width={child.text.length * 10} // Dynamic width
                    height={20} // Fixed height
                    fill="#705CFE"
                    rx="5"
                    ry="5"
                  />
                  {/* Rotated Text */}
                  <text
                    fontSize="14"
                    fill="white"
                    textAnchor="middle"
                    alignmentBaseline="middle"
                  >
                    {child.text}
                  </text>
                </g>
              </g>
            );
          })
        )}
      </svg>
      {nodes.map((node) => (
        <div
          key={node.id}
          className="node-box"
          style={{ left: node.x, top: node.y }}
          ref={(el) => (dragRefs.current[node.id] = el)}
          onMouseDown={(e) => handleMouseDown(e, node.id)}
        >
          {node.id === "start" && (
            <>
              <strong className="p-2 bg-light w-100">Starting Step</strong>
            </>
          )}
          <div className="node-text w-100 p-2 text-white text-bold text-center">
            {node.text}
          </div>

          <div className=" p-2">
            {node.id === "start" ? (
              <>
                <div className="bg-light p-2">
                  <p>
                    Select the first response to send to the customer when they
                    say 'Hi'.{" "}
                  </p>
                </div>
              </>
            ) : (
              <>
                {/* <p>Thanks for your cart!
              Would you like to continue with purchase? </p> */}
              </>
            )}
          </div>

          {node.id === "start" ? (
            <div className=" p-2 w-100 d-flex justify-content-center flex-column ">
              <div className="  p-2 w-100  bg-light button-group">
                {buttonTypes.map((type, index) => (
                  <button
                    key={index}
                    className="btn-flow-builder w-100 bg-light"
                    ref={(el) => (refs.current[`${node.id}-${index}`] = el)}
                    onClick={() => addNode(node.id, type, index)}
                  >
                    {type}
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div>
              {node.text === "Template Message" && (
                <>
                  <div className=" p-2">
                    <select
                      className="form-select cursur-pointer"
                      onChange={(e) =>
                        handleTemplateSelect(e.target.value, node.id)
                      }
                    >
                      <option value="">Select a Template</option>
                      {templates.map((item, index) => (
                        <option key={item.id} value={JSON.stringify(item)}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {node.template &&
                  node.template.components &&
                  Array.isArray(node.template.components) ? (
                    <>
                      {node.template.components.map((item, index) => (
                        <div key={index} className="p-2">
                          {item.type === "BUTTONS" && (
                            <>
                              {item.buttons &&
                                Array.isArray(item.buttons) &&
                                item.buttons.map((item2, index2) => (
                                  <div
                                    key={index2}
                                    className="bg-light border my-3 p-3"
                                  >
                                    <div>{item2.type}</div>
                                    <div>Button Name: {item2.text}</div>
                                    {item2.type === "QUICK_REPLY" ? (
                                      <>
                                        <div>
                                          <select
                                            className="form-select"
                                            ref={(el) => {
                                              refs.current[
                                                `${node.id}-dropdown`
                                              ] = el;
                                            }}
                                            onChange={(e) => {
                                              const selectedValue =
                                                e.target.value;
                                              const index =
                                                e.target.selectedIndex - 1;

                                              if (selectedValue) {
                                                refs.current[
                                                  `${node.id}-${index}`
                                                ] = e.target;
                                                addNode(
                                                  node.id,
                                                  selectedValue,
                                                  index
                                                );
                                              }
                                            }}
                                          >
                                            <option value="">
                                              Select an option
                                            </option>
                                            {buttonTypes.map((type, index) => (
                                              <option key={index} value={type}>
                                                {type}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {item2.type === "URL" ? (
                                          <>User Go to Website</>
                                        ) : (
                                          <>User Call on Phone Number</>
                                        )}
                                      </>
                                    )}
                                  </div>
                                ))}
                            </>
                          )}
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      <p>No template selected</p>
                    </>
                  )}
                </>
              )}
              {node.text === "Catalog" && (
                <div className="p-2">
                  <p>Catalog Section</p>
                </div>
              )}
              {node.text === "Text Message" && (
                <div className="p-2">
                  <p>Text Message Section</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your text message"
                    value={textMessage}
                    onChange={(e) => setTextMessage(e.target.value)}
                  />
                </div>
              )}

              {node.text === "Interactive List" && (
                <div className="p-2">
                  <p>Interactive List Section</p>
                  <input
                    type="textarea"
                    className="form-control mb-2"
                    placeholder="Enter Message"
                    value={listTitle}
                    onChange={(e) => setListTitle(e.target.value)}
                  />
                  <hr />
                  {interactiveList.map((item, index) => (
                    <div key={index} className="p-2 bg-light border my-3">
                      <div className="d-flex  align-items-center mb-2">
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder={`Button ${index + 1}`}
                          value={item}
                          onChange={(e) =>
                            handleInteractiveListChange(index, e.target.value)
                          }
                        />
                        {/* <button className="btn btn-danger" onClick={() => removeListItem(index)}>Remove</button> */}
                      </div>
                      <div>
                        {/* <p>Select action </p> */}
                        <select
                          className="form-select"
                          ref={(el) => {
                            refs.current[`${node.id}-dropdown`] = el;
                          }}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            const index = e.target.selectedIndex - 1;

                            if (selectedValue) {
                              refs.current[`${node.id}-${index}`] = e.target;
                              addNode(node.id, selectedValue, index);
                            }
                          }}
                        >
                          <option value="">Select Action</option>
                          {buttonTypes.map((type, index) => (
                            <option key={index} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ))}
                  {interactiveList.length < 5 && (
                    <button
                      className="gray-button mt-2"
                      onClick={addListItem}
                    >
                      Add Button
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
